'use strict';

import {Type} from 'main.core';
import {Fields} from './fields.js';

export class Configurator
{
    constructor(options = {})
    {
        const self = this
        const opt = options
        new Fields(options);

        this.reInitSelect()
        this.selectRed()
        this.changePage()
        this.changeRows()
        this.initRange()
        this.form = $('#conf-form')

        $('.js-custom-select[name="reducer_type"]').on('change', function(e) {
            // Название типа редуктора на четвертом шаге
            $('#total-type').html($(this).val())

            // Схема монтажной позиции по умолчанию при выборе типа редуктора
            $('.mv-img').attr('src', $(this).find(':selected').data('img-url'))

            // Схема монтажной позиции по умолчанию при выборе типа редуктора (если не выбрано)
            $('.js-custom-select[name="mounting_version"] option:first').attr('data-img-url', $(this).find(':selected').data('img-url'))
        })

        // Схема монтажной позиции
        $('.js-custom-select[name="mounting_version"]').on('change', function(e) {
            $('.mv-img').attr('src', $(this).find(':selected').data('img-url'))
        })

        // Схема монтажной позиции для варианта исполнения с фланцем
        $('.js-custom-select[name="mounting_version_flange"]').on('change', function(e) {
            $('.mv-img').attr('src', $(this).find(':selected').data('img-url'))
        })

        $('.js-custom-select[name="version"]').on('change', function() {
            let code = $(this).find('option:selected').data('code');
            // console.log(code);
            if (code === 'v_flange') {
                $('.js-parent-field[data-code="mounting_version"]:visible').hide()
                $('.js-parent-field[data-code="version"]:visible').before($('.js-parent-field[data-code="mounting_version_flange"]'));
            } else {
                $('.js-parent-field[data-code="mounting_version"]').show()  
            }
        });

        // Схемы монтажной позиции (если не выбрано)
        $('.js-custom-select[name="mounting_version"] option:first').on('change', function(e) {
            $('.mv-img').attr('src', $('.js-custom-select[name="reducer_type"]').data('img-url'))
        })

        // Опции на третьем шаге
        $(".form-control--number").on('change', function () {
            let inputId = $(this).data('id')
            let measure = $(this).data('measure')

            $('.conf__total-row[data-id="'+inputId+'"]').removeClass('d-none').addClass('conf__option-show')
            $('.conf__total-row[data-id="'+inputId+'"] .conf__total-val').text($(this).val())
            $('.conf__total-row[data-id="'+inputId+'"] .conf__total-measure').text(measure)
        })


        // Опции на третьем шаге
        $('.custom-control-input[type="radio"]').on('change', function (){
            let control = $(this)
            let option = control.parents('.accordion').find('[data-btn="'+control.data('parent-id')+'"]').html()

            // self.setFourControl(option, control.val())

            // передаем значение в правую колонку Опции на третьем шаге
            let optionSelectedId = control.data('parent-id')
            $('.option-val[data-id="'+optionSelectedId+'"]').html(control.val())

            // передаем значение в блок Опции на четвертом шаге
            self.optionFourControl(control)
        })

        // Для групп опции Смазочные материалы
        $('body').on('click', '.group-radio-input', function (){
            let control = $(this)
            let optionSelectedId = control.data('group-parent-id')

            // передаем значение в правую колонку Опции на третьем шаге
            $('.option-val[data-id="'+optionSelectedId+'"]').html(control.val())

            // передаем значение в блок Опции на четвертом шаге
            $('.finish__option-val[data-id="'+optionSelectedId+'"]').html(control.val())

            // оставляем только выбранную опцию, убираем отмеченные в других группах
            control.parents($('.form-group')).siblings().find($('.group-radio-input')).prop('checked', false);
        })

        // Получение данных для сводной таблицы на четвертом шаге
        $(".js-custom-select, .form-control--number").on('change', function () {
            let field = $(this)
            self.setFourthTab($(this), opt)
            self.request()

            let fieldId = field.find(':selected').data('parent-id')

            let name = field.prev('label').text()
            let value = field.val()
            let measure = field.data('measure')
            let resMeasure = (measure !== undefined) ? measure : '';
            let code = field.attr('name');
    
            let html = '<tr class="conf__total-row" data-name="'+name+'" data-code="'+code+'" data-parent-id="'+fieldId+'">' +
                '<td class="conf__total-title">'+name+'</td>' +
                '<td class="conf__total-val">'+value+'</td>' +
                '<td class="conf__total-measure">'+resMeasure+'</td>' +
                '</tr>'
    
            $(html).appendTo($('#conf-total-result'))      
            
            $('.conf__total-row').each(function () {
                if ($(this).attr('data-code') === 'reducer_type') {
                    $(this).hide()
                }
                if ($(this).attr('data-name') === name) {
                    $(this).siblings('.conf__total-row[data-name="'+name+'"]').hide()
                    $(this).show()
                } 
            })
        })

        $('#conf-export-btn').on('click', function (e) {
            e.preventDefault();
            $.ajax({
                type: "POST",
                url: '/local/ajax/api/v1/csv_new.php',
                data: { 'conf_table': JSON.stringify(self.generateCsv()) }
            }).done(function(filePath){
                let obj = JSON.parse(filePath)
                let a = document.createElement("a");
                a.setAttribute("href", obj.filePath);
                a.setAttribute("download", "");
                a.click();
            })
        })

        $(document).on('submit', '.conf-order-form', function(e){
            e.preventDefault();
            let form = $(this);
            // let data = form.serialize();
            let formData = new FormData(form[0]);
            formData.append('conf_table', JSON.stringify(self.generateCsv()));

            $.ajax({
                method: "POST",
                url: '/local/ajax/form/conf_order.php',
                data: formData,
                processData: false,
                contentType: false,
            }).done(function(e){ym(5592460,'reachGoal','konfigurator-zakazat-reductor');
                form.html(e);
            });
        });

        $('.form-control--number').keyup(function() {
            let numb = $(this).val();
            numb = numb.replace(",", ".");
            $(this).val(numb)
        });

    }

    generateCsv()
    {
        let conf_table = [];

        let info = {}
        let totalModel = $('#total-model').parent()
        let totalType = $('#total-type').parent()

        info.TitleType = totalType.find('small').html()
        info.ValType = totalType.find('span').html()

        conf_table.push(info)

        info = {}
        info.TitleModel = totalModel.find('small').html()
        info.ValModel = totalModel.find('span').html()

        conf_table.push(info)

        $('#conf-total-result').find('.conf__total-row:visible').each(function(){
            let item = {}
            let tableRow = $(this)

            item.Title = tableRow.find('td.conf__total-title').text()
            item.Val = tableRow.find('td.conf__total-val').text()
            item.Measure = tableRow.find('td.conf__total-measure').text()

            conf_table.push(item)
        })

        $('.finish-options-total').find($('.selection__prop')).each(function(){
            let add_options = {}
            let optRow = $(this)

            add_options.TitleOption = optRow.find($('.finish__option-name')).text()
            add_options.ValOption = optRow.find($('.finish__option-val')).text()

            conf_table.push(add_options)
        })

        // console.log(conf_table)

        return conf_table;
    }

    selectRed()
    {
        const self = this
        let table = $('.options__list-wrap')

        // Название модели на четвертом шаге
        $(document).on("click", ".conf__result-product", function () {
            table.find('.conf__result-product.selected').removeClass('selected')

            let row = $(this)
            row.addClass('selected')
            let name = row.find('.conf__result-product-name').text()
            $('#total-model').text(name)

            console.log(row)

            self.setFourControl(BX.message('CONF_FORM_MOTORS_POWER'), row.find('[data-prop="ENGINE_POWER"]').html(), BX.message('CONF_FORM_MOTORS_POWER_MEASURE'))
            self.setFourControl(BX.message('CONF_FORM_TORQUE'), row.find('[data-prop="TORQUE"]').html(), BX.message('CONF_FORM_TORQUE_MEASURE'))
            self.setFourControl(BX.message('CONF_FORM_OUTPUT_SPEED'), row.find('[data-prop="OUTPUT_SHAFT_SPEED"]').html(), BX.message('CONF_FORM_OUTPUT_SPEED_MEASURE'))
            self.setFourControl(BX.message('CONF_FORM_SERVICE_FACTOR'), row.find('[data-prop="SERVICE_FACTOR"]').html(), BX.message('CONF_FORM_SERVICE_FACTOR_MEASURE'))
            self.setFourControl(BX.message('CONF_FORM_RADIAL_LOAD'), row.find('[data-prop="RADIAL_LOAD"]').html(), BX.message('CONF_FORM_RADIAL_LOAD_MEASURE'))
            self.setFourControl(BX.message('CONF_FORM_RATIO'), row.find('[data-prop="RATIO"]').html(), BX.message('CONF_FORM_RATIO_MEASURE'))

            $('.conf__tab-link.disabled').removeClass('disabled')
            $('.btn-primary--next.to_step2').removeClass('disabled')
        })
    }

    changePage()
    {
        const self = this

        $(document).on('click', '.js-select-page a', function(e){
            e.preventDefault();
            self.request($(this).attr('href'))
        });
    }

    changeRows()
    {
        const self = this

        $(document).on('change', '.js-select-default', function(e){
            e.preventDefault();
            self.request()
        });
    }

    optionFourControl(control)
    {
        let radioId = control.data('parent-id')
        let radioVal = control.val()

        $('.conf__total-row[data-id="'+radioId+'"]').removeClass('d-none').addClass('conf__option-show')
        $('.conf__total-row[data-id="'+radioId+'"] .conf__total-val').text(radioVal)

        // задаем значение в правую колонку
        // $('.option-val[data-id="'+radioId+'"]').html(radioVal)

        //задаем значение во вкладку "сводная информация"
        $('.finish__option-val[data-id="'+radioId+'"]').html(radioVal)
    }

    setFourControl(name, value, measure)
    {
        if ($('#conf-total-result').find('tr[data-name="'+name+'"]').length > 0) {

            $('#conf-total-result').find('tr[data-name="'+name+'"]').find('.conf__total-val').html(value)

        } else {

            let fieldId = $(".js-custom-select, .form-control--number").find(':selected').data('parent-id')

            let html = '<tr class="conf__total-row" data-name="'+name+'" data-parent-id="'+fieldId+'">' +
                '<td class="conf__total-title">'+name+'</td>' +
                '<td class="conf__total-val">'+value+'</td>' +
                '<td class="conf__total-measure">'+measure+'</td>' +
                '</tr>'

            $(html).appendTo($('#conf-total-result'))

        }
    }

    setFourthTab($elem, opt) {
        let selected = $elem.find('option:selected')
        let option = selected.data('option-id')
        let selectId = $elem.data('id')
        let block = $elem.parents('.js-parent-field')
        let redTypeId = $('.js-custom-select[name="reducer_type"]').find(':selected').data('option-id')
        let arr = []

        // скрыть все соседние элементы у которых id родителя не соответствует id выбранной опции на втором шаге
        $('.show-' + option).siblings().addClass('d-none')
        // $('[class *= "show-"]').addClass('d-none')

        if (!!block && block.length > 0 && block.data('allparent') != '') {
            arr = block.data('allparent').split(',')

            arr.forEach(function (item) {
                if (parseInt(item) > 0) {
                    $('.show-' + item).removeClass('d-none')
                    // $('.show-' + item).siblings().addClass('d-none')                    
                }
            })
        }

        // показать поля у которых id родителя соответствует выбранному типу редуктора на втором шаге
        $('.show-' + redTypeId).removeClass('d-none')
        $('.show-' + option).removeClass('d-none')
        $('.show-' + $elem.data('parent-id')).removeClass('d-none')

        // Передача значений в сводную таблицу на четвертом шаге
        $('.conf__total-row[data-id="' + selectId + '"]').removeClass('d-none').addClass('conf__option-show')
        $('.conf__total-row[data-id="' + selectId + '"] .conf__total-val').text($elem.val())
        $('.conf__total-row[data-id="' + selectId + '"] .conf__total-measure').text(opt.measurement)
    }

    // Переинициализация плагина select2
    reInitSelect()
    {
        $('.js-custom-select').select2({
            language: 'ru',
            minimumResultsForSearch: Infinity,
            width: '100%',
            templateResult: function(state){
                return $('<span>'+ state.text + '</span>')
            },
            templateSelection: function(state){
                return $('<span>'+ state.text + '</span>')
            }
        })
    }

    // Вывод таблицы подбора на первом шаге
    request(url = '/local/ajax/api/v1/reducer_selection.php')
    {
        let data = this.form.serialize()

        $.ajax({
            url: url,
            data: data,
            method: 'POST'
        }).done(function(e){
            $(".options__list-wrap").html(e);
            // console.log('append')

            if(!$('*').is('.js-selection-table-res')) {
            // if ($('.js-selection-table-res').length < 0) {
                $('.js-selection-res-buttons').addClass('d-none')
                // console.log('hide')
            }

            if (!$(".conf__tab-link").hasClass('disabled')) {
                $('.btn-primary--next').removeClass('disabled')
            } else {
                $('.btn-primary--next').addClass('disabled')
            }

            $('.conf__tab-link.disabled').addClass('disabled')
            $('.btn-primary--next.to_step2').addClass('disabled')

            $('.btn-primary--next').on('click', function () {
                let tabId = $(this).data('tab-id')
                let tabLink = $('.nav-tabs--full .nav-link[data-tab-id="'+tabId+'"]')
                tabLink.removeClass('disabled')
                $('.nav-tabs--full .nav-link').removeClass('active')
                tabLink.addClass('active')
            })
        });
    }

    // Иницализация плагина noUiSlider
    initRange()
    {
        const self = this
        let timer = null

        $('.initrange').each(function(){
            let range = this
            let idrange = $(this).data('range-id')
            let inputFrom = document.getElementById('in-'+idrange+'_from')
            let inputTo = document.getElementById('in-'+idrange+'_to')
            let start = parseInt($(this).data('start')*100)/100
            let end = parseInt($(this).data('end')*100)/100

            noUiSlider.create(range, {
                start: [start, end],
                connect: true,
                step: 0.01,
                tooltips: true,
                range: {
                    'min': start,
                    'max': end
                }
            })

            range.noUiSlider.on('update', function(values, handle) {

                if(!!timer) {
                    clearTimeout(timer);
                }

                timer = setTimeout(function(){
                    self.request()
                }, 1000);

                let value = values[handle]
                if (handle) {
                    inputTo.value = value
                } else {
                    inputFrom.value = value
                }
            })

            inputFrom.addEventListener('change', function() {
                range.noUiSlider.set([this.value, null])
            })

            inputTo.addEventListener('change', function() {
                range.noUiSlider.set([null, this.value])
            })
        })
    }

    setName(name)
    {
        if (Type.isString(name))
        {
            this.name = name;
        }
    }

    getName()
    {
        return this.name;
    }

}